import { HomeHeading, HomeLink } from './presentation'
import styles from './home.module.css'

export function Responsive() {
  return (
    <section className={styles.section} aria-labelledby="home-device-title">
      <div className={`${styles.container} ${styles.devicePanel}`}>
        <div>
          <HomeHeading
            id="home-device-title"
            title="Built to be completed on every device"
          >
            A smooth experience on mobile, tablet, and desktop. Your audience
            can respond wherever they are.
          </HomeHeading>
          <HomeLink href="https://my.heyform.net/sign-up">
            Create a form that works everywhere
          </HomeLink>
        </div>
        <div className={styles.media}>
          <img
            src="/static/responsive.webp"
            alt="The same HeyForm displayed on a laptop, tablet, and phone"
            width={2560}
            height={2560}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  )
}
